import styled from 'styled-components';
import ModalProps from './type';

export const BasicModalStyled = styled.div<ModalProps>`
  display: ${({ open }) => (open ? 'block' : 'none')};
  max-width: 90vw;
  max-height: 90vh;
  background-color: #fff;
  box-shadow: 4px 4px 20px 0px rgba(111, 140, 176, 0.41), 2px 2px 4px 0px rgba(114, 142, 171, 0.1);
  border-radius: 12px;
  position: fixed;
  z-index: 999999;
  pointer-events: auto !important;
  overflow: hidden;
  ${({ hideBackdrop }) => !hideBackdrop && `box-shadow: 0 0 0 100vmax rgba(0,0,0,0.25);`}
  @media (min-width: 350px) {
    padding: ${({ variant }) => {
      switch (variant) {
        case 'alert':
        case 'informative':
          return '32px';
        case 'notification':
          return '22px 16px';
        default:
          return '0px';
      }
    }};
    min-width: ${({ variant }) => {
      switch (variant) {
        case 'alert':
        case 'informative':
          return '323px';
        case 'notification':
          return '284px';
        default:
          return 'unset';
      }
    }};
  }
  @media (max-width: 350px) {
    padding: ${({ variant }) => {
      switch (variant) {
        case 'alert':
        case 'informative':
          return '18px 32px';
        case 'notification':
          return '14px 22px';
        default:
          return '0px';
      }
    }};
    min-width: 220px;
  }

  ${({ ubication }) => {
    switch (ubication) {
      case 'top':
        return `
            top: 0;
            left: 50%;
            transform: translate(-50%, 0);
            `;
      case 'bottom':
        return `
            bottom: 0;
            left: 50%;
            transform: translate(-50%, 0);
            `;
      case 'left':
        return `top: 50%; left: 0; transform: translate(0, -50%);`;
      case 'right':
        return `
            top: 50%;
            right: 0;
            transform: translate(0, -50%);
            `;
      case 'top-left':
        return ` 
            top: 0;
            left: 0;
            transform: translate(0, 0);
            `;
      case 'top-right':
        return `
            top: 0;
            right: 0;
            transform: translate(0, 0);
            `;
      case 'bottom-left':
        return `
            bottom: 0;
            left: 0;
            transform: translate(0, 0);
            `;
      case 'bottom-right':
        return `
            bottom: 0;
            right: 0;
            transform: translate(0, 0);
            `;
      default:
        return `
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            `;
    }
  }}
`;

export const CenterModalBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
  gap: 20px;
  ${({ theme }) => theme.typography.body3}
  color: ${({ theme }) => theme.colors.gray700};
  @media (max-width: 350px) {
    font-size: 13px;
  }
`;

export const ExitButtonStyled = styled.div<ModalProps>`
  position: relative;
  display: grid;
  grid-template-columns: max-content 1fr max-content;
  align-items: start;
  justify-content: center;
  width: 100%;
  background-color: transparent;
  border: 0;
  ${({ theme }) => theme.typography.body3}
  color: ${({ theme }) => theme.colors.gray700};
  @media (max-width: 350px) {
    font-size: 13px;
  }
`;

export const ItemModalStyled = styled.div<ModalProps>`
  margin-right: 16px;
  background: ${({ type }) => {
    switch (type) {
      case 'informative':
        return 'linear-gradient(130deg, rgb(0, 87, 184, 0.6), rgb(164, 202, 245, 0.3))';
      case 'error':
        return 'linear-gradient(130deg, rgb(250, 190, 179, 0.6), rgb(255, 89, 63, 0.6))';
      case 'success':
        return 'linear-gradient(130deg, rgb(210, 238, 155, 0.6), rgb(149, 211, 28, 0.6))';
      default:
        return 'linear-gradient(130deg,rgb(253, 227, 161, 1), rgb(255, 226, 168, 0.4))';
    }
  }};
  border: 1px solid
    ${({ type }) => {
      switch (type) {
        case 'informative':
          return '#A5C4E6';
        case 'error':
          return 'rgb(232, 166, 167, 0.4)';
        case 'success':
          return 'rgb(210, 238, 157)';
        default:
          return 'rgb(254, 193, 51, 0.4)';
      }
    }};
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  border-radius: 9px;
  box-shadow: -4px -4px 9px 0px rgba(255, 255, 255, 0.6) inset;

  width: max-content;
  height: max-content;
  padding: 6px;
`;

export const ConfirmButtonWrapperStyled = styled.div<ModalProps>`
  display: flex;
  align-items: center;
  gap: 10px;
  @media (max-width: 350px) {
    flex-direction: column-reverse;
  }
`;
